export const ACCOUNT_ALREADY_EXISTS_MODAL = "account-already-exists-modal";
export const ACCOUNT_ALREADY_EXISTS_MODAL_TITLE =
  "account-already-exists-modal-title";
export const ACCOUNT_ALREADY_EXISTS_MODAL_CONTENT_1 =
  "account-already-exists-modal-content-1";
export const ACCOUNT_ALREADY_EXISTS_MODAL_CONTENT_2 =
  "account-already-exists-modal-content-2";
export const ACCOUNT_ALREADY_EXISTS_MODAL_CONTENT_3 =
  "account-already-exists-modal-content-3";
export const YOU = "account-already-exists-modal-you";
export const THIS_USER = "account-already-exists-modal-this-user";
